// local
// export const baseURL = "http://127.0.0.1:5000";
export const baseURL = "https://routesrez.com/api";
// export const baseURL = "https://caledontec.com/rms_test_python";
